import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  booleanAttribute,
} from '@angular/core';

@Component({
  selector: 'ss-heading',
  templateUrl: './ng-heading.component.html',
  styleUrls: ['./ng-heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class NgHeadingComponent {
  @Input() heading: number | string = '';
  @Input({ transform: booleanAttribute }) underline = false;
  @Input() label: number | string | undefined | null = '';
  @Input() alt = '';

  get tag(): string {
    return `h${this.heading}`;
  }
}
